import { AppType } from '~/graphql/types';
import { AppConfig } from '../types';
import { HELP_DESK_LINK } from '~/constants';

const description = `
## Omschrijving
Ben je een NVM Makelaar? Maak dan kennis van onze nieuwe leadgeneratie tool de BiedWijzer! In een exclusieve samenwerking met brainbay - dochterbedrijf van de NVM - heeft BNDL deze app ontwikkeld.

De BiedWijzer gebruikt recente transacties en marktinformatie om huizenzoekers te informeren wat een realistisch bod is voor de woning die ze op het oog hebben. Het rapport bevat marktinformatie en de acceptatiekans van diverse biedingen. Genereer een aankoop-, verkoop- en hypotheekadvieslead! 

Nieuwe leads ontvang je in het BNDL portaal. Geen tijd om leads op te volgen? Kies voor LeadAssist om door ons aan- en verkoopafspraken te laten inplannen op basis van no-cure-no-pay. 


## Installatie en kosten
De app kost €50,- per maand, inclusief 25 maandelijks actieve contacten. Een actief contact is een persoon die gedurende de facturatiemaand één of meerdere keren de BiedWijzer opvraagt. Boven de inbegrepen 25 wordt €1,99 per maandelijks actief contact in rekening gebracht. 

Gebruik na installatie de beschikbare flow templates om de juiste opvolging voor nieuwe leads in te stellen.
`;

const termsOfUse =
  'Voor het gebruik van deze app dien je lid te zijn van de NVM. Voor de toegang en het gebruik van transactiegegevens uit de Tiara uitwisseling gelden de algemene voorwaarden van het NVM lidmaatschap. Zodra je NVM lidmaatschap beëindigd, zal automatisch de toegang tot deze app worden ingetrokken. Door deze app te activeren ga je akkoord dat BNDL periodiek hiervoor extra kosten in rekening brengt.';

export const biedwijzer: AppConfig = {
  __typename: 'AppStatus_Biedwijzer',
  appType: AppType.Biedwijzer,
  type: 'with_config',
  slug: 'biedwijzer',
  name: 'BiedWijzer',
  tags: ['Leadgeneratie', 'E-mailcampagne'],
  provider: 'BNDL',
  logo: {
    src: 'https://dvihwe5maugou.cloudfront.net/stash/BiedWijzerLogo.svg',
  },
  image: {
    src: 'https://dvihwe5maugou.cloudfront.net/stash/BiedWijzerLogo.svg',
  },
  price: {
    interval: {
      amount: 1,
      duration: 'month',
    },
    amount: 5000,
    currency: 'EUR',
  },
  description,
  termsOfUse,
  compatibility: 'Alleen beschikbaar voor leden van de NVM',
  help: {
    href: `${HELP_DESK_LINK}/nl/articles/12683097-over-de-biedwijzer`,
  },
  setupFlow: 'oAuth',
  hasWidgetAppItems: true,
  visibility: 'visible',
  cancellability: 'daily',
  wizard: 'default',
};

const emptyLine = `<div><br/></div>`;

/**
 * Default values for input fields
 */
export const getDefaultValues = (accountName?: string | undefined) => ({
  general: {
    privacyStatement: {
      nl: `Door het versturen van dit formulier geef ik ${accountName} toestemming mij per e-mail de BiedWijzer toe te sturen en tot drie keer per e-mail en/of per telefoon contact met mij op te nemen met meer informatie over gerelateerde dienstverlening bij de koop of verkoop van een huis. Meer informatie vind je in onze privacyverklaring.`,
      en: `By submitting this form, I authorize ${accountName} to send me the BiedWijzer by email and to contact me up to three times by email and/or phone with more information about related services for buying or selling a home. You can find more details in our privacy policy.`,
    },
  },
  aboutUs: {
    heading: {
      nl: 'Maak kennis met onze aankoopmakelaar',
      en: 'Get to know our buying agent',
    },
    body: {
      nl: `<div>Leuk dat je de BiedWijzer gebruikt!</div><div>Wij helpen je graag om met vertrouwen te bieden op jouw droomhuis.</div>${emptyLine}<div>De woningmarkt verandert snel. Wat is een woning echt waard? Hoe ver ga je met bieden? En wanneer wacht je beter nog even? Wij geven duidelijke antwoorden op basis van marktdata, ervaring en gezond verstand. Samen vertalen we de inzichten uit de BiedWijzer naar een biedplan dat past bij jouw situatie en gevoel bij de woning.</div>${emptyLine}<div>Wij staan volledig aan jouw kant en begeleiden je persoonlijk van de eerste bezichtiging tot aan de sleuteloverdracht.</div>${emptyLine}<div>Wil je weten hoe wij jou verder kunnen helpen? Laten we kennismaken.</div>`,
      en: `<div>Great to see you using the BiedWijzer!</div><div>We’re here to help you bid on your dream home with confidence.</div>${emptyLine}<div>The housing market changes quickly. What is a home really worth? How far should you go with your offer? And when is it wiser to wait? We provide clear answers based on market data, experience, and sound judgment. Together, we turn the insights from your BiedWijzer into a bidding plan that fits your situation and your feelings about the home.</div>${emptyLine}<div>We are fully on your side and personally guide you from the first viewing to the moment you receive the keys.</div>${emptyLine}<div>Would you like to know how we can help you further? Let’s get in touch.</div>`,
    },
  },
  addressSearch: {
    aboutUsButton: {
      nl: 'Maak kennis met onze aankoopmakelaar',
      en: 'Get to know our buying agent',
    },
  },
});
